// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-action-menu {
    list-style-type: none;
    margin: 0;
    padding: 20px 0
}

@media(width < 750px) {
    .group-action-menu {
        padding: 0;
    }
    .group-action-menu .button {
        font-size: 16px;
    }
    .text {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/groups/components/GroupActionMenu.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,SAAS;IACT;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".group-action-menu {\n    list-style-type: none;\n    margin: 0;\n    padding: 20px 0\n}\n\n@media(width < 750px) {\n    .group-action-menu {\n        padding: 0;\n    }\n    .group-action-menu .button {\n        font-size: 16px;\n    }\n    .text {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
